export default __webpack_public_path__ + "static/media/trv_3.7e6a27cc.jpg";